import { Component, OnInit, ViewChild } from '@angular/core';
import { PatientModel, PatientScheduleModel } from '../../../models/patient';
import { LoginModel } from '../../../models/account';
import { PatientResponsibilityAccountModel } from '../../../models/PatientResponsibilityAccount';
import { MenuItem } from 'primeng/api';
import { AppConfig, AccountService, PatientsService, PatientResponsibilityAccountsService, PatientScheduleService, ClientMessagingService } from '../../../core';
import { Menu } from 'primeng/menu';
import { GeneralSettingsModel } from '../../../models/account/generalSettingsModel';
import { MessageThreadModel } from '../../../models/messaging';
@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  standalone: false
})
export class NavMenuComponent implements OnInit {
  items: MenuItem[];
  timeoutDoxy;
  creditCardPaymentEnabled: boolean = false;
  canMakePayment: boolean = false;

  get loggedUser() { return this.accountService.currentUser; }
  doxyMeSessions: PatientScheduleModel[];
  loading: boolean = false;

  get generalSettings(): GeneralSettingsModel {
    return this.accountService ? this.accountService.generalSettings : null;
  }
  constructor(
    public accountService: AccountService,
    public patientsService: PatientsService,
    public patientResponsibilityAccountsService: PatientResponsibilityAccountsService,
    private patientScheduleService: PatientScheduleService,
    private clientMessagingService: ClientMessagingService,
  ) {

    patientsService.$patients.subscribe(data => {
      this.loadMenuItems();
      this.loadDoxyMeEvent();
    });

    patientResponsibilityAccountsService.$accounts.subscribe(data => {
      this.loadMenuItems();
    });

    clientMessagingService.$receivers.subscribe(data => {
      this.loadMenuItems();
    });
  }

  ngOnInit() {
    this.loadMenuItems();
  }

  getPatientDisplayName(patient: PatientModel): string {
    if (!patient) {
      return '';
    }

    const fullName = `${patient.firstName || ''} ${patient.lastName || ''}`.trim();
    return patient.inactive ? `${fullName} (INACTIVE)` : fullName;
  }

  loadMenuItems() {
    this.creditCardPaymentEnabled = this.accountService
      && this.accountService.currentUser
      && this.accountService.currentUser.systemFeatureIDs
      && !!this.accountService.currentUser.systemFeatureIDs.find(x => x === 82);

    var patients: Array<any> = [];
    const portalPatients = this.patientsService.patients || [];

    if (portalPatients.length > 0 && portalPatients.length <= 10) {
      patients = [... portalPatients
        .map(patient => ({
        label: this.getPatientDisplayName(patient),
        icon: patient.isSelf? 'fal fa-fw fa-user-alt': 'fal fa-fw fa-user',
        routerLink: [`/patient/${patient.inquiryID}`]
      }))];
    }

    var accounts: Array<any> = [];


    if (this.patientResponsibilityAccountsService.accounts && this.patientResponsibilityAccountsService.accounts.length > 0 && this.patientResponsibilityAccountsService.accounts) {
      accounts = [... this.patientResponsibilityAccountsService.accounts.map(account => ({
        label: (account.isSelf) ? 'My Account' : account.name,
        icon: (account.isSelf) ? 'fal fa-fw fa-wallet' : 'fal fa-fw fa-money-bill',
        routerLink: [`/client/account/${account.patientResponsibilityAccountID}`]
      }))];
      /*
      if (this.patientResponsibilityAccountsService.accounts.length > 1) {

        accounts.push({
          label: 'View Accounts',
          icon: 'fal fa-fw fa-wallet',
          routerLink: ['/account'],
          queryParams: { show: 'all' }
        })
      }
      */
      accounts.push(
        {
          label: 'Invoices',
          icon: 'fal fa-fw fa-file-invoice-dollar',
          routerLink: ['/client/invoice']
        });
      accounts.push(
        {
          label: 'Notices',
          icon: 'far fa-fw fa-bell',
          routerLink: ['/notices']
        });
        
    //    ...accountFirstCreditSubItem,
      //    ...accountSecondCreditSubItem,

      this.canMakePayment = this.patientResponsibilityAccountsService.accounts.find(a => a.canMakePayments) != null
      if (this.canMakePayment && this.creditCardPaymentEnabled) {
        accounts.push(
          {
            label: 'Receipts',
            icon: 'fal fa-fw fa-receipt',
            routerLink: ['/client/receipt']
          });
        accounts.push(
          {
            label: 'Make Payment',
            icon: 'fal fa-fw fa-credit-card-front',
            routerLink: ['/client/payment']
          });
      
      }

      accounts.push({
        separator: true
      });
    }


    


    
    var messagesItem = [];
    if (this.clientMessagingService.canSendReceiveMessage) {
      messagesItem = [
        
        {
          separator: true
        },{
            label: 'View Messages',
          icon: 'fal fa-fw fa-comments',
            routerLink: ['/messaging/message-list'],
        },
        {
          label: 'New Message',
          icon: 'fal fa-fw fa-comment-plus',
          routerLink: ['/messaging/message-send'],
        }      ];
    }


    this.items = [

      {
        label: 'Patients',
        items: [
          ...patients,
          {
            label: 'View Patients',
            icon: 'fal fa-fw fa-users',
            routerLink: ['/'],
            queryParams: { show: 'all' }
          },
          //{
          //  label: 'Add Patient',
          //icon: 'fal fa-fw fa-user-plus',
          //  routerLink: ['/patient/add']
          //}
          ...messagesItem,
        ]
      },
      {
        label: 'Account',
        //    icon: 'fal fa-fw fa-money-bill',
        items: [

          ...accounts,
         
          {
            label: 'Profile / Settings',
            icon: 'fal fa-fw fa-user-cog',
            routerLink: ['/client/settings']
          },
          {
            label: 'Logout',
            icon: 'fal fa-fw fa-sign-out',
            routerLink: ['/login']
          }
          ]
      }];


  }

  loadDoxyMeEvent() {

    if (this.loggedUser != null) {
      this.patientScheduleService.getOpenDoxyMeSession().subscribe(sessions => {
        this.doxyMeSessions = sessions;
        if (this.timeoutDoxy){
          clearTimeout(this.timeoutDoxy);
        }
        this.timeoutDoxy = setTimeout(() => { this.loadDoxyMeEvent() }, 120000);
      });
    }
  }

  openDoxyMe(session: PatientScheduleModel) {
    this.loading = true;
    this.patientScheduleService.getDoxyMeSession(session.patientHasEventID).subscribe(doxyMeLink => {
      this.loading = false;
      window.open(doxyMeLink.link, "_blank");
    }, () => {
      this.loading = false;
    });
  }
}
